(function ($) {
    "use strict";
    $(function () {
        if(!$('.map').length){
            return;
        }
        
        var ojjektum = new google.maps.LatLng(47.504277, 19.135227);
        var mapOptions = {
            zoom: 15,
            center: ojjektum
        };
        var map = new google.maps.Map(document.querySelector('.map'), mapOptions);
        var marker = new google.maps.Marker({
            position: ojjektum,
            map: map
        });
    });
})(jQuery);